export default __webpack_public_path__ + "static/media/mercantil.535a9533.png";